import { ApiResponse } from '@nohara-dxdev/oidc-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { ItemInfrastructureEntity } from '@/types/api';

/**
 * Get all infrastructures where the item is a sub item
 */
export const getInfrastructureOfSubItems = async (
  orgId: string,
  projectId: string,
  itemId: string,
): Promise<ItemInfrastructureEntity[]> => {
  const { data } = await api.get<undefined, ApiResponse<ItemInfrastructureEntity[]>>(
    `/orgs/${orgId}/projects/${projectId}/items/${itemId}/infrastructures/sub`,
  );
  return data;
};

export const getInfrastructureOfSubItemsQueryKey = (
  orgId?: string,
  projectId?: string,
  itemId?: string,
) => {
  const queryKey: unknown[] = ['infrastructure-sub-items'];
  if (orgId) queryKey.push('org', orgId);
  if (projectId) queryKey.push('project', projectId);
  if (itemId) queryKey.push('item', itemId);
  return queryKey;
};

export const getInfrastructureOfSubItemsQueryOptions = (
  orgId?: string,
  projectId?: string,
  itemId?: string,
): UseQueryOptions<ItemInfrastructureEntity[]> => {
  return {
    queryKey: getInfrastructureOfSubItemsQueryKey(orgId, projectId, itemId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getInfrastructureOfSubItems(orgId!, projectId!, itemId!),
    enabled: !!orgId && !!projectId && !!itemId,
  };
};

export const useInfrastructureOfSubItems = (
  itemId?: string,
  queryConfig?: Omit<UseQueryOptions<ItemInfrastructureEntity[]>, 'queryKey' | 'queryFn'>,
) => {
  const { orgId, projectId } = useScopeIds('org', 'project');
  return useQuery({
    ...getInfrastructureOfSubItemsQueryOptions(orgId, projectId, itemId),
    ...queryConfig,
  });
};
